import React from "react";
import { Box, Flex, Avatar, Text } from "samba-ui";

const RegistrationUsersOverview = ({ registrations = [] }) => {
  if (!registrations.length) {
    return null;
  }

  return (
    <Box
      minHeight={60}
      maxHeight={120}
      overflow="scroll"
      border="1px solid"
      borderColor="#d6d6d6"
      borderRadius={4}
      mb={3}
    >
      {registrations.map((registration, index) => {
        const { imageURL, email, name } = registration;
        return (
          <Flex
            key={email}
            alignItems="center"
            p={3}
            borderBottom={
              index === registrations.length - 1 ? "none" : "1px solid #d6d6d6"
            }
          >
            <Avatar src={imageURL} mr={2} width={30} height={30} />
            <Box>
              <Box>
                <Text fontSize={1} color="palette.ink.normal">
                  {name}
                </Text>
              </Box>
              <Text fontSize={1} color="palette.ink.normal">
                {email}
              </Text>
            </Box>
          </Flex>
        );
      })}
    </Box>
  );
};

export default RegistrationUsersOverview;
